import axios from 'axios'

const API_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party'

export const getOrganization = (query, token) =>
  axios.post(
    API_URL,
    {
      query: query,
    },
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Token ' + token,
      },
    }
  )
